import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, Inject, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, Form, FormControl } from '@angular/forms';
import { FormBuilderService } from '../../services/form-builder.service';
import { DatastoreService, ApiService, CommonFunctionsService } from '../../services';
import { DOCUMENT } from '@angular/common';
import moment from 'moment-timezone';

@Component({
  selector: 'app-form-builder',
  templateUrl: './form-builder.component.html',
  styleUrls: ['./form-builder.component.scss']
})
export class FormBuilderComponent implements OnInit {

  @Input() formId: string;
  @Input() formData: any = [];
  @Input() showSubmit: boolean = true;
  @Input() booking: any = false;
  @Input() maxChildren: number = 4;
  @Input() uploadSuccess: EventEmitter<boolean>;
  @Output() formSubmitted = new EventEmitter<FormGroup>();
  @Output() formStatus = new EventEmitter<any>();
  @Output() fileStatus = new EventEmitter<any>();

  formFields: any[] = [];
  formGroups: any = {};
  childForms: any[] = [];
  @Input() attachedFiles: any[] = [];
  @Input() deletedFiles: any[] = [];

  detailsTitle: string = '';
  children: any[] = [[]];
  errorLength = 999;
  fileData: any = []

  constructor(
    public formService: FormBuilderService,
    public dataStore: DatastoreService,
    public commonFunctionsService: CommonFunctionsService,
    private api: ApiService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private doc: Document
  ) { }

  async ngOnInit(): Promise<void> {
    console.log('formId', this.formId);
    if (this.dataStore.loadedApplication) {
      if (this.dataStore.loadedApplication.length > 0) {
        this.children = this.dataStore.loadedApplication;
      }
    }

    if (this.uploadSuccess) {
      this.uploadSuccess.subscribe(data => {
        this.preLoadFiles()
      });
    }
    this.populateForms(true);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.hasOwnProperty('formData')) {
      // get the data to add to form
      this.populateForms(changes.formData.currentValue['hafId']);
    }
  }

  async addChild() {
    if (this.children.length < this.maxChildren) {
      const formGroup = await this.formService.buildForm(this.formId, [], this.children.length);
      const formFields = this.formService.getFields(this.formId);
      this.childForms = [formGroup];
      this.formFields = [formFields];
      this.children = [];

      this.formChanges(this.children.length - 1);

      const script = this.renderer.createElement('script');
      script.type = 'application/javascript';
      script.text = `window.setTimeout(function(){document.getElementById('summary-child-${this.children.length}').click();}, 100);`;

      // this.renderer.appendChild(this.doc.body, script);
    }
  }

  removeChild() {
    if (this.children.length > 1) {
      this.children.pop();
      this.formChanges(this.children.length - 1);
    }
  }

  removeChildAtIndex(idx: number) {
    if (this.children.length > 1) {
      this.children.splice(idx, 1);
      this.childForms.splice(idx, 1);
      this.formFields.splice(idx, 1);
      for (const idx in this.children) {
        this.formChanges(parseInt(idx));
        this.forceRevalidationForIndex(parseInt(idx));
      }
    }
  }

  async submit(formId: string) {
    this.formSubmitted.emit(this.formGroups[this.formId]);
  }

  formChanges(idx: number) {
    this.childForms[idx].valueChanges.subscribe((selectedValue: any) => {
      if (this.children[idx]) {
        let currentChild = this.children[idx];
        // now get the values and place them into the array
        // populate the current child
        for (const field of this.formFields[idx]) {
          if (selectedValue.hasOwnProperty(field.field)) {
            const inputtedValue = selectedValue[field.field];
            const foundKey = currentChild.find((f: any) => f.field === field.field);
            if (foundKey) {
              foundKey.value = inputtedValue;
            }
            else {
              currentChild.push({ field: field.field, value: inputtedValue });
            }
          }

          // dates
          if (field.type === 'date') {
            const dobVal: string = selectedValue[field.field + 'y'] + '-' + selectedValue[field.field + 'm'].padStart(2, '0') + '-' + selectedValue[field.field + 'd'].padStart(2, '0');
            this.childForms[idx].controls[field.field].setValue(dobVal, { onlySelf: true });
            // RPD-20: the day/month/year boxes are the controls the user
            // actually touches, so the combined control stays untouched and
            // its errors would never be shown. Mark it once the three parts
            // are filled, otherwise a hide_dates_in_future breach would block
            // submission with no message on screen.
            if (/^\d{4}-\d{2}-\d{2}$/.test(dobVal)) {
              this.childForms[idx].controls[field.field].markAsTouched();
            }
          }
        }

        // update validators based on conditional fields
        for (const field of this.formFields[idx]) {
          const control: FormControl = this.childForms[idx].get(field.field);
          if (field.conditional) {
            const trigger = this.childForms[idx].get(field.trigger);
            if (trigger && trigger.value) {
              // get value of trigger
              // doing it this way did not work. 
              // see shouldShowConditional in form builder for new way of handling the requirement of conditional fields
              // reason why we don't enable/disable here is that that causes a recursive loop (enabling/disabling counts as a valueChange)
              if (trigger.value !== field.conditional_value) {
                // control.setValidators([]); 
              }
              else {
                // control.setValidators([Validators.required]);
              }
              control.updateValueAndValidity({ onlySelf: true });
            }
          }
        }
        this.forceRevalidationForIndex(idx);
      }
    });
  }

  async uploadTest(idx: number, field: any, event: Event) {
    console.log(idx, event, this.childForms)
    const target: HTMLInputElement = (event.target as HTMLInputElement);
    console.log(target);
    for (const file of Array.from(target.files!)) {

      console.log("copyFile",)
      console.log("copyFile", file == undefined)
      console.log(JSON.stringify(file));
      const formData = new FormData();
      // formData.append("file", "");
      formData.append("attachment_id", "");
      formData.set("file", file)
      console.log(JSON.stringify(formData));

      let reader = new FileReader();
      console.log(file);
      if (this.attachedFiles.find((x) => x.name === file.name)) {
        alert("you have already uploaded a file with the name " + file.name)
        target.value = '';
        return
      }
      this.attachedFiles.push(formData);

      reader.onload = async (e: any) => {
        console.log(field, this.childForms[idx].get(field.field))
        console.log(this.childForms[idx].get(field.field).controls)
        if (!this.childForms[idx].get(field.field).controls) {
          this.childForms[idx].get(field.field).controls = []
        }
        if (!this.dataStore.filesStrings[field.field]) {
          this.dataStore.filesStrings[field.field] = []
        }
        this.childForms[idx].get(field.field).controls.push(this.formService.createItem({
          file,
          url: e.target.result  //Base64 string for preview image
        }));
        this.dataStore.filesStrings[field.field].push({
          file: { name: file.name },
          // url: e.target.result  //Base64 string for preview image
        });
        this.childForms[idx].get(field.field).value = this.dataStore.filesStrings[field.field]
        this.fileStatus.emit({
          attachedFiles: this.attachedFiles,
          deletedFiles: this.deletedFiles,
        })
        this.forceRevalidationForIndex(0)
      }
      reader.readAsDataURL(file);
      target.value = '';
    }
  }

  async removeFileAtIndex(name: string, field: any, idx: number, event: Event) {
    event.preventDefault();
    // const deletedFileControl = JSON.parse(JSON.stringify(this.childForms[idx].get(field.field).controls.find((x)=> x.value.file.name === name)))
    this.childForms[idx].get(field.field).controls = this.childForms[idx].get(field.field).controls.filter((x) => x.value.file.name !== name);
    console.log(this.childForms[idx].get(field.field).controls)
    // now get the file id
    console.log(name)
    console.log(this.attachedFiles)
    const deletedFile = JSON.parse(JSON.stringify(this.attachedFiles.find((x) => x.name === name)))
    this.attachedFiles = this.attachedFiles.filter((x) => {
      console.log(x.name, name)
      console.log(x.name !== name)
      return x.name !== name
    })

    // const deletedFile = this.attachedFiles.splice(fileIdx, 1) as any;
    // await this.api.deleteFile(fileId);
    const newFIleList = this.dataStore.filesStrings[field.field].filter((x) => x.file.name !== name)
    this.childForms[idx].get(field.field).value = newFIleList
    this.dataStore.filesStrings[field.field] = newFIleList

    // console.log(deletedFileControl);
    console.log(newFIleList);
    console.log(deletedFile);
    if (deletedFile) {
      if (deletedFile.uuid) {
        this.deletedFiles.push(deletedFile)
      }
    }
    this.fileStatus.emit({
      attachedFiles: this.attachedFiles,
      deletedFiles: this.deletedFiles,
    })
    this.forceRevalidationForIndex(0)

  }

  async preLoadFiles() {
    console.log("whyyyy")
    this.dataStore.filesStrings = {}
    const files: any = await this.api.jrniReadFiles(JSON.parse(this.dataStore.config), this.booking.company_id, this.booking.purchase_ref, this.booking.id)
    console.log("files", files)
    console.log(this.childForms[0])
    const uploadFields = this.formFields[0].filter((x: any) => x.type === "upload")
    console.log("uploadFields", uploadFields)
    this.deletedFiles = []
    this.attachedFiles = []
    for (let uploadField of uploadFields) {
      this.childForms[0].get(uploadField.field).controls = []
      this.dataStore.filesStrings[uploadField.field] = []
      if (files.attachments && this.childForms[0].get(uploadField.field).value) {
        let finder = this.childForms[0].get(uploadField.field).value
        console.log(finder.length, this.childForms[0].get(uploadField.field).value)
        try {
          finder = JSON.parse(finder)
        } catch (err) {

        }

        // for (let file of files.attachments) {
        for (let find of finder) {
          console.log(find)

          const file = files.attachments.find((x) => {
            return find.file.name === x.name
          }
          )
          console.log(uploadField.field)
          console.log(this.childForms[0].get(uploadField.field).value)
          if (file) {
            // if (finder.find((x) => x.file.name === file.name) !== undefined) {
            file.size = file.file_size
            console.log(uploadField)
            console.log(uploadField.field)
            console.log(this.childForms[0].get(uploadField.field))
            console.log(this.childForms[0].get(uploadField.field).controls)
            this.childForms[0].get(uploadField.field).controls.push(this.formService.createItem({
              file,
              url: file.url  //Base64 string for preview image
            }));
            this.dataStore.filesStrings[uploadField.field].push({
              file: { name: file.name },
            });
            const formData = new FormData();
            formData.append("attachment_id", "");
            formData.set("file", file)
            this.attachedFiles.push(file)
            // }
          }

        }
        console.log(this.childForms[0])
        console.log("uploadField.field", uploadField.field)
        console.log("uploadField.field", this.childForms[0])
        console.log("uploadField.field", this.childForms[0].get(uploadField.field))
        console.log("uploadField.field", this.dataStore.filesStrings[uploadField.field])
        this.childForms[0].get(uploadField.field).patchValue(this.dataStore.filesStrings[uploadField.field])
      }
      console.log(this.childForms[0].get(uploadField.field))
    }
    console.log(this.attachedFiles)
    this.fileStatus.emit({
      attachedFiles: this.attachedFiles,
      deletedFiles: this.deletedFiles,
    })
    this.forceRevalidationForIndex(0)
  }

  onDateChange(reference: string, QuestionsForm: any) {
    const d = QuestionsForm.controls[reference + "d"]
    const m = QuestionsForm.controls[reference + "m"]
    const y = QuestionsForm.controls[reference + "y"]
    if (d.value && m.value && y.value) {
      const date = moment(`${d.value}/${m.value}/${y.value}`, "DD/MM/YYYY").utc().tz('Europe/London')
      if (!date.isValid()) {
        d.setErrors({ error: 'Date is invalid' });
      } else if (date.isBefore(moment().utc().tz('Europe/London').subtract(JSON.parse(this.dataStore.config).eligibility.age + 1, "years"))) { // young person max age 25 (and a person is 25 for a year so +1)
        d.setErrors({ error: 'Child/young person is not eligible' });
      } else {
        d.setErrors(null);
      }
    }
  }

  forceRevalidationForIndex(idx: number) {
    const hasErrors: any[] = [];
    for (const field of this.formFields[idx]) {
      const control: FormControl = this.childForms[idx].get(field.field);
      if (field.conditional) {
        const trigger = this.childForms[idx].get(field.trigger);
        if (trigger && trigger.value) {
          // get value of trigger
          // doing it this way did not work. 
          // see shouldShowConditional in form builder for new way of handling the requirement of conditional fields
          // reason why we don't enable/disable here is that that causes a recursive loop (enabling/disabling counts as a valueChange)
          if (trigger.value !== field.conditional_value) {
            // control.setValidators([]);
          }
          else {
            // control.setValidators([Validators.required]);
          }
          control.updateValueAndValidity({ onlySelf: true });
        }
      }
    }

    for (const field of this.formFields[idx]) {
      const control = this.childForms[idx].get(field.field);
      if (control && !control.disabled) {
        field.value = control.value;
        const child = this.children[idx].find((x) => x.field === field.field)
        if (child) {
          child.value = control.value;
        }
      }
      if (control && control.errors) {
        hasErrors.push({
          field: field,
          control: control
        });
      }
    }
    const atLeastOneCheckbox: any = this.commonFunctionsService.checkBoxGroupsCheck(JSON.parse(this.dataStore.config), this.childForms[idx].controls, this.formId)
    if (!atLeastOneCheckbox.allAtLeastOne) {
      for (let errorField of atLeastOneCheckbox.errorFields)
        hasErrors.push({
          field: errorField,
          control: this.childForms[idx].get(errorField)
        });
    }
    console.log("vthis.children", this.children)
    this.dataStore.childrenToRegister = this.children;

    if (this.errorLength !== hasErrors.length) {
      if (hasErrors.length > 0) {
        this.formStatus.emit({
          status: false,
          errors: hasErrors
        });
      }
      else {
        this.formStatus.emit({
          status: true,
          errors: []
        });
      }
    }
    this.errorLength = hasErrors.length
  }

  async populateForms(formDataKey: any) {
    if (formDataKey) {

      let foundChild: any = false;

      for (const [idx, child] of this.children.entries()) {
        console.log(this.formData)
        console.log(this.booking)

        const formGroup: FormGroup = await this.formService.buildForm(this.formId, this.formData, idx);
        const formFields = this.formService.getFields(this.formId);
        // load any defaults
        const defaults: any = [];

        if (this.dataStore.loadedApplication) {
          for (const field of child) {
            let found = formFields.find((f: any) => f.field == field.field);
            if (found) {
              defaults.push(field);
            }
          }
        }

        // const radioFields = formData[0].filter((x: any) => {

        //   const schemaField = schema.find((y) => y.field === x.field && y.type === "radio")
        //   if (schemaField) {
        //     x.schemaField = schemaField
        //     return true
        //   } else {
        //     return false
        //   }
        // })
        // console.log(radioFields)
        // for (let radioField of radioFields) {
        //   const value = radioField.schemaField.radio_options.find((x) => x.value === radioField.value)
        //   if (value) {
        //     radioField.value = value.title
        //   }
        // }
        for (const k of Object.keys(formGroup.controls)) {
          const ctrl = formGroup.get(k);
          const field = formFields.find((f: any) => f.field == k);
          const foundDefault = defaults.find((f: any) => f.field == k);
          if (foundDefault) {
            if (foundDefault && foundDefault.value && foundDefault.value.toString().length > 0) {

              if (field.type === 'radio') {
                const schema = this.dataStore.schema.schema.fields

                console.log('radio', foundDefault, k, schema)
                const schemaField = schema.find((x) => x.field === foundDefault.field)
                const option = schemaField.radio_options.find((x) => x.title === foundDefault.value)
                if (option) {
                  foundDefault.value = option.value
                }
                ctrl?.setValue(foundDefault.value);
                ctrl?.updateValueAndValidity({ onlySelf: true });
              }
              else if (field.type === 'date') {

                const parts = foundDefault.value.split('-');
                const dayCtrl = formGroup.get(k + 'd');
                const monthCtrl = formGroup.get(k + 'm');
                const yearCtrl = formGroup.get(k + 'y');
                if (dayCtrl && monthCtrl && yearCtrl) {
                  if (parts.length >= 1) {
                    yearCtrl.setValue(parts[0]);
                    yearCtrl?.updateValueAndValidity({ onlySelf: true });
                  }
                  if (parts.length >= 2) {
                    monthCtrl.setValue(parts[1]);
                    monthCtrl?.updateValueAndValidity({ onlySelf: true });
                  }
                  if (parts.length >= 3) {
                    dayCtrl.setValue(parts[2]);
                    dayCtrl?.updateValueAndValidity({ onlySelf: true });
                  }
                }
              }
              else {
                ctrl?.setValue(foundDefault.value);
                ctrl?.updateValueAndValidity({ onlySelf: true });
              }
            }
          }
        }
        this.childForms.push(formGroup);
        this.formFields.push(formFields);
        this.formGroups[this.formId] = formGroup;
        this.detailsTitle = this.formService.getDetailsTitle(this.formId);
        await this.preLoadFiles()
        // now set up changes
        this.formChanges(idx);
      }
    }
  }

}
